export default __webpack_public_path__ + "static/media/icon-factura.e0c18cff.svg";